module.exports = __webpack_public_path__ + "img/Biologia.83309ee7.png";